import { Button } from '@crazyegginc/hatch';
import { Panel } from '../SsoUi';
import { SupportLinks } from '/src/support';
import { SupportLink } from '/src/features/_global/components/SupportLink';

export function GeneralErrorMessage() {
  return (
    <Panel>
      <p className="text-body-2 mb-7">
        An error prevented the Single Sign-On configuration from loading. Please check your connection and try again
        later. If the issue persists, please contact support.
      </p>
      <div className="flex gap-x-2.5">
        <Button component={SupportLink} href={SupportLinks.general.newSupportRequest}>
          Contact Support
        </Button>
      </div>
    </Panel>
  );
}
